<template>
  <transition :name="transition">
    <div
      class="van-toast van-toast--middle van-toast--loading"
      style="z-index: 2002"
      v-show="value"
    >
      <div class="van-loading van-loading--circular van-toast__loading">
        <span class="van-loading__spinner van-loading__spinner--circular"
          ><svg viewBox="25 25 50 50" class="van-loading__circular">
            <circle cx="50" cy="50" r="20" fill="none"></circle></svg
        ></span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'miniLoading',
  data() {
    return {
      transition: 'van-fade',
      value: false
    }
  },
  methods: {
    show() {
      this.value = true
    },
    hide() {
      this.value = false
    }
  }
}
</script>
<style lang="scss" scoped>
.van-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: initial;
  width: 88px;
  max-width: 70%;
  min-height: 88px;
  padding: 16px;
  color: #fff;
  font-size: 14px;
  line-height: 20px;
  white-space: pre-wrap;
  text-align: center;
  word-wrap: break-word;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 8px;
  transform: translate3d(-50%, -50%, 0);
}
.van-toast__loading {
  padding: 4px;
  color: #fff;
}

.van-loading {
  color: #c8c9cc;
  font-size: 0;
}

.van-loading,
.van-loading__spinner {
  position: relative;
  vertical-align: middle;
}

.van-loading__spinner {
  display: inline-block;
  width: 30px;
  max-width: 100%;
  height: 30px;
  max-height: 100%;
  animation: van-rotate 0.8s linear infinite;
}
.van-loading__spinner--circular {
  animation-duration: 2s;
}

.van-loading__circular {
  display: block;
  width: 100%;
  height: 100%;
}

.van-loading__circular circle {
  animation: van-circular 1.5s ease-in-out infinite;
  stroke: currentColor;
  stroke-width: 3;
  stroke-linecap: round;
}

.van-toast--loading {
  width: 0.8rem;
  height: 0.8rem;
  min-height: auto;
  background-color: rgba(0, 0, 0, 0.4);
}
.van-fade-enter-active {
  animation: van-fade-in 0.3s ease-out both;
}

.van-fade-leave-active {
  animation: van-fade-out 0.3s ease-in both;
}

@keyframes van-circular {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -40;
  }

  to {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -120;
  }
}
@keyframes van-rotate {
  0% {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(1turn);
  }
}

@keyframes van-fade-in {
  0% {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes van-fade-out {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}
</style>
